import React from 'react'
import { FormControl, FormErrorMessage } from '@chakra-ui/react'
import Checkbox from './Checkbox'

export default function FormCheckBox({ label, value, error, classNameHolder, ...props }) {
  return (
    <FormControl className={classNameHolder} isInvalid={error && error.touched && error.error}>
      <Checkbox defaultChecked={value} {...props}>
        {label}
      </Checkbox>
      <FormErrorMessage>{error && error.error}</FormErrorMessage>
    </FormControl>
  )
}
